import { API_BASE_URL } from '../utils/constants';
import axiosInstance from './axiosInstance';

export const WatermarkService = {
	/**
	 * Create checkout session for one-time watermark removal.
	 * @param {string} documentId
	 * @param {string} successUrl
	 * @param {string} cancelUrl
	 */
	createCheckoutSession: async (documentId, successUrl, cancelUrl) => {
		try {
			const response = await axiosInstance.post(`${API_BASE_URL}/watermark-removal/checkout`, {
				documentId,
				successUrl,
				cancelUrl
			});

			return {
				status: response.status,
				data: response.data,
				...response.data
			};
		} catch (error) {
			throw error;
		}
	}
};

